export const filters = {
  clients_name: {
    label: 'Klantnaam',
  },
  clients_type: {
    label: 'Type klant',
  },
  credit_notes_brand: {
    label: 'Handelsnaam',
  },
  credit_notes_client: {
    label: 'Klant',
  },
  credit_notes_doc_quarter: {
    label: 'Kwartaal',
  },
  credit_notes_doc_year: {
    label: 'Jaar',
  },
  credit_notes_status: {
    label: 'Status',
  },
  invoice_templates_brand: {
    label: 'Handelsnaam',
  },
  invoice_templates_client: {
    label: 'Klant',
  },
  invoice_templates_type: {
    label: 'Type',
  },
  invoices_brand: {
    label: 'Handelsnaam',
  },
  invoices_client: {
    label: 'Klant',
  },
  invoices_doc_quarter: {
    label: 'Kwartaal',
  },
  invoices_doc_year: {
    label: 'Jaar',
  },
  invoices_status: {
    label: 'Status',
  },
  products_activity_type: {
    label: 'Soort prestatie',
  },
  products_categories: {
    label: 'Categorieën',
  },
  products_status: {
    label: 'Status',
  },
  quarter: {
    option: 'Kwartaal {{quarter}} - {{year}}',
  },
  quotations_brand: {
    label: 'Handelsnaam',
  },
  quotations_client: {
    label: 'Klant',
  },
  quotations_doc_quarter: {
    label: 'Kwartaal',
  },
  quotations_doc_year: {
    label: 'Jaar',
  },
  quotations_status: {
    label: 'Status',
  },
};
